import { render, staticRenderFns } from "./event_registration_old.vue?vue&type=template&id=b5e7e686&"
import script from "./event_registration_old.vue?vue&type=script&lang=js&"
export * from "./event_registration_old.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports